// @floww
import styled from 'styled-components';
import * as CommonTable from 'common/components/ui/Table';

export const Td = styled(CommonTable.Td)`
  padding-top: 0;
  padding-bottom: 0;
  
  cursor: default;
`;

export {
  Table,
  THead,
  TBody,
  Th,
  Tr,
} from 'common/components/ui/Table';



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/components/CustomerTable.js